import { StopObject } from '../../app/DTOs/StopObject.component';

export class ItinerarioObject {
    private id: string;
    private id_linea: string;
    private name: string;
    private lineHeader: string;
    private lineEnd: string;
    private stops: StopObject[] = [];

    constructor( id: string, id_linea: string, name: string, lineHeader: string, lineEnd: string, stops: StopObject[] ) {
        this.id = id;
        this.id_linea = id_linea;
        this.name = name;
        this.stops = stops;
        this.lineHeader  = lineHeader;
        this.lineEnd  = lineEnd;
    }

    public setId (id: string) { this.id = id; }
    public getId () { return this.id; }
    
    public setId_linea (id_linea: string) { this.id_linea = id_linea; }
    public getId_linea() { return this.id_linea; }
    
    public setName (name: string) { this.name = name; }
    public getName () { return this.name; }
    
    public setLineHeader (lineHeader: string) { this.lineHeader = lineHeader; }
    public getLineHeader () { return this.lineHeader; }
    
    public setLineEnd (lineEnd: string) { this.lineEnd = lineEnd; }
    public getLineEnd () { return this.lineEnd; }
    
    public setStops (stops: StopObject[]) { this.stops = stops; }
    public getStops () { return this.stops; }
    
    public searchForId (idSearched: string) {
        if (idSearched == this.id) {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/DTOs/ItinerarioObject.component.ts